export default __webpack_public_path__ + "static/media/home.a82cf8b3.svg";